module.exports = __webpack_public_path__ + "img/single-sided.a49e9231.svg";